module.exports = __webpack_public_path__ + "img/noresult.e4faf8c8.png";